import React from 'react';
import PropTypes from 'prop-types';

import NavigationItem from './NavigationItem';

const NavigationList = ({ navItems }) => (
    <div className="rn-navigation rn-wrapper">
        <div className="rn-canvas">
            <nav>
                <ul className="rn-secondaryNav">
                    <li className="rn-secondaryNav__item">
                        <ul className="rn-secondaryNav__list">
                            {navItems.map(item => (
                                <NavigationItem key={item.label} {...item} />
                            ))}
                        </ul>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
);

NavigationList.propTypes = {
    navItems: PropTypes.arrayOf(PropTypes.shape({
        isSelected: PropTypes.bool.isRequired,
        link: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
};

export default NavigationList;



// WEBPACK FOOTER //
// ./src/js/secondaryNavigation/NavigationList.jsx